import { lazy } from "react";

const Security = lazy(() => import("../Component/Security/Security"));

const securityRoutes = [{ path: "/security", element: <Security />, protected: true }];

export default securityRoutes;
